export { default } from 'common/validations/forgot-password';
